import '../../styles/form.css';
import './crm/kanban-list-switcher';
import './crm/action';
import { isDOMElementVisible } from './util/isVisibleInDomUtil';

for (const elem of document.querySelectorAll('#myTab [data-tabs-target]')) {
    elem.addEventListener('click', function () {
        window.history.replaceState({}, '', `#tab=${this.getAttribute('data-tabs-target').replace('#', '')}`);
    });
}

function openDetailsElementFromNavigation(window) {
    const hash = window.location.hash.replace('#', '');
    let params = new URLSearchParams(window.location.search);

    if (!params.has('tab')) {
        params = new URLSearchParams(hash);
    }

    if (!params.has('tab')) {
        return;
    }

    const tabButton = document.querySelector(`[data-tabs-target='#${params.get('tab')}']`);

    if (tabButton) {
        setTimeout(() => {
            tabButton.click();
        }, 500);
    }
}

openDetailsElementFromNavigation(window);

const errorContainer = document.querySelector('#deal-error-warning-container');
const mandatoryFieldContainer = document.querySelector('#mandatory-fields-container');
mandatoryFieldContainer?.classList.add('hidden');

for (const form of document.getElementsByName('update_deal')) {
    for (const elem of form.querySelectorAll('input[data-important], select[data-important]')) {
        let element = errorContainer.querySelector(`[data-id="${elem.id}"]`);
        const label = elem.previousElementSibling || form.querySelector(`label[for="${elem.id}"]`);

        if (!element) {
            element = document.createElement('li');
            element.dataset.id = elem.id;
            element.classList.add('hidden', 'cursor-pointer', 'hover:underline');
            element.textContent = `${label.textContent} is nog niet ingevuld`;
            errorContainer.appendChild(element);

            element = errorContainer.querySelector(`[data-id="${elem.id}"]`);
            element.addEventListener('click', () => {
                if (!isDOMElementVisible(elem)) {
                    // Check if the field is hidden inside a tab
                    const tabPanel = elem.closest('[role=tabpanel]');

                    if (tabPanel) {
                        document.querySelector(`[data-tabs-target="#${tabPanel.id}"]`)?.click();
                    }
                }

                elem.focus();
            });
        }

        function showError() {
            element.classList.remove('hidden');
            mandatoryFieldContainer.classList.remove('hidden');
            mandatoryFieldContainer.classList.add('bg-accent-400', 'text-secondary-600');
            elem.classList.add('important');

            setTimeout(() => {
                mandatoryFieldContainer.classList.remove('bg-accent-400', 'text-secondary-600');
            }, 400);
        }

        if (elem.value.length === 0) {
            showError();
        }

        elem.addEventListener('input', function () {
            const isValid = elem.value.length > 0 && this.checkValidity();

            if (!isValid) {
                showError();
                return;
            }

            elem.classList.remove('important');
            element.classList.add('hidden');

            if (errorContainer.querySelectorAll('li:not(.hidden)').length === 0) {
                mandatoryFieldContainer.classList.add('hidden');
            }
        });
    }

    for (const child of form.querySelectorAll('menu[aria-labelledby=actionButton] li a')) {
        child.addEventListener('click', () => {
            if (!form.checkValidity()) {
                return;
            }

            // Submit to the server and issue a background save with the current form data
            fetch(form.action, {
                method: 'POST',
                body: new FormData(form),
            }).then((r) => {
                if (r.ok) {
                    return r.text();
                }

                throw new Error('Something went wrong while saving the deal in the background');
            });
        });
    }
}

document.addEventListener('click', (event) => {
    const form = event.target.closest('form[name=create_deal], form[name=update_deal]');
    const companyTypeElement = form?.querySelector('#create_deal_customer_company_companyType, #update_deal_customer_company_companyType');

    if (!companyTypeElement) {
        return;
    }

    const changeEvent = (e) => {
        const currentAddress = form.closest('#create_deal_customer_address_street, #update_deal_customer_address_street');

        if (currentAddress?.value.length > 0) {
            return;
        }

        const sourceElements = form.querySelectorAll('.form-field[id*=customer_company_address_]');

        for (const sourceElement of sourceElements) {
            const updateTargetElement = () => {
                const targetElement = form.querySelector(`#${sourceElement.id.replace('customer_company_address_', 'customer_address_')}`);

                if (!targetElement) {
                    return;
                }

                targetElement.value = sourceElement.value;
                targetElement.dispatchEvent(new Event('change'));
            };

            sourceElement.removeEventListener('change', updateTargetElement);
            sourceElement.addEventListener('change', updateTargetElement);
        }
    };

    companyTypeElement.removeEventListener('change', changeEvent);
    companyTypeElement.addEventListener('change', changeEvent);
});
